export const UploadImageRoute = 
{
    uploadImage:"admin/upload-product-image"
}